export default "<div (click)=\"goBack()\" class=\"fecharCamera\">\n  <ion-icon name=\"close-outline\"></ion-icon>\n</div>\n<div id=\"sdk-displayer\">\n\n</div>"